import { useEffect, useRef } from "react";
import { scienceSteps } from "../data/siteData";
import "./Science.css";

export default function Science() {
  const ref = useRef(null);
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("visible"); obs.unobserve(e.target); } }),
      { threshold: 0.1 }
    );
    ref.current?.querySelectorAll(".reveal").forEach((el) => obs.observe(el));
  }, []);

  return (
    <section id="science" className="section science" ref={ref}>
      <div className="leaf-pattern" />
      <div className="science__inner">
        <div className="reveal">
          <span className="section-eyebrow">Our R&D Process</span>
          <h2 className="section-title">From Lab to <em>Label</em></h2>
          <p className="science__sub">
            Every CropShield product goes through a rigorous multi-year pipeline of discovery, development,
            and regulatory approval before reaching your farm.
          </p>
        </div>

        <div className="science__steps reveal">
          {scienceSteps.map((s) => (
            <div className="sci-step" key={s.num}>
              <div className="sci-step__num">{s.num}</div>
              <span className="sci-step__icon">{s.icon}</span>
              <h3 className="sci-step__title">{s.title}</h3>
              <p className="sci-step__desc">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="science__bar reveal">
          {[
            { label: "Efficacy Rate",      val: 98 },
            { label: "Crop Safety",        val: 96 },
            { label: "Eco Safety Score",   val: 91 },
            { label: "Rainfastness",       val: 94 },
          ].map((b) => (
            <div className="sci-bar" key={b.label}>
              <div className="sci-bar__top">
                <span>{b.label}</span>
                <span className="sci-bar__pct">{b.val}%</span>
              </div>
              <div className="sci-bar__track">
                <div className="sci-bar__fill" style={{ width: `${b.val}%` }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
